import fireBase from 'firebase/app'

import {images, CricrushConfig} from "./../cc-imports";

let storageBucket ='gs://'+CricrushConfig.firebaseConfig.storageBucket + '/';

const STORES = {
    "PROFILE_PICS":"private/profile_pics",
    "PROFILE_PICS_THUMBNAILS":"private/profile_pics/thumbnails",
}

const ImageUtils = {
    getBannerImage(url){
        return {uri : url, cache: 'force-cache'};
    },
    getProfilePicSrc(user){
        return (user && user.imageUrl) ?  user.imageUrl : images.icons.avatar;
        return (user && user.imageUrl ? {uri : user.imageUrl, cache: 'force-cache'} : images.icons.avatar);
    },
    getThumbnailProfilePicSrc(user){
        return (user && user.thumbnailUrl ? {uri : user.thumbnailUrl} : images.icons.profile_pic_plh);
    },
    uploadProfilePicture(userId, uploadUri, response, successCallback, errorCallback){
        const imageRef = fireBase.storage().ref(STORES.PROFILE_PICS).child(`${userId}`);
        imageRef.putFile(uploadUri, {contentType: 'image/jpg'}).then(successCallback).catch(errorCallback);
    },
    getProfilePicUrl(id, callback, errorCallback) {
        fireBase.storage().refFromURL(storageBucket+STORES.PROFILE_PICS+'/'+id).getDownloadURL().then(function(url) {
            callback && callback(url);
        }).catch(function(error) {
            errorCallback && errorCallback();
        });
    },
    getProfilePicThumbnail(id, callback, errorCallback) {
        fireBase.storage().refFromURL(storageBucket+STORES.PROFILE_PICS_THUMBNAILS+'/'+id).getDownloadURL().then(function(url) {
            callback && callback(url);
        }).catch(function(error) {
            errorCallback && errorCallback();
        });
    },
    openProfileImagePicker (successCallback) {
        /*if(Platform.OS === 'ios'){
            var options = {
                title: strings('change_profile_picture'),
                mediaType : 'photo',
                quality : 0.5,
                allowsEditing : true,
                storageOptions: {
                    skipBackup: true,
                    path: 'images'
                }
            };

            ImagePicker.showImagePicker(options, (response) => {

                if (response.didCancel) {
                    //console.log('User cancelled image picker');
                }
                else if (response.error) {
                    //console.log('ImagePicker Error: ', response.error);
                }
                else if (response.customButton) {
                    //console.log('User tapped custom button: ', response.customButton);
                }
                else {

                    const uploadUri = Platform.OS === 'ios' ? response.uri.replace('file://', '') : response.uri;
                    successCallback(uploadUri, response);

                }
            });
        }
        else {
            ImageCropPicker.openPicker({
                width: 300,
                height: 300,
                mediaType : 'photo',
                compressImageQuality : 0.5,
                cropping: true
            }).then(image => {
                //console.log(image);
                successCallback(image.path, image);
            }).catch((error)=>{
                //console.log(error);
            });
        }*/

    }
};

export {ImageUtils};


// WEBPACK FOOTER //
// ./src/app/lib/ImageUtils.js